import { ContentWrap, WrapImg } from '../../style'
import { RestrictedByWidthMobile } from '../MainWrapperWithCaptions/style'
import { TextDescription } from '../../pages/StageOne/WrapFormContent'
import React from 'react'
import { Wrap } from './style'

export const FinalPage = () => {
  return (
    <Wrap>
      <ContentWrap>
        <RestrictedByWidthMobile>
          <WrapImg>
            <img src="/face.png" alt=""/>
          </WrapImg>
          <TextDescription>Und solltest Du einen persönlichen Ratschlag brauchen, kannst Du mich jederzeit anrufen oder mir eine Email schreiben. <br />
            <img src="/phone_icon.svg" alt=""/> +49 30 2018 1715 <br />
            <img src="/email_icon.svg" alt=""/> karsten.knorr@yachtcharterfinder.com
          </TextDescription>
        </RestrictedByWidthMobile>
      </ContentWrap>
    </Wrap>
  )
}
